import { render } from "./SidebarMenuItem.vue?vue&type=template&id=0751b50e&scoped=true"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"

import "./SidebarMenuItem.vue?vue&type=style&index=0&id=0751b50e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0751b50e"],['__file',"src/components/SidebarPlugin/SidebarMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0751b50e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0751b50e', __exports__)) {
    api.reload('0751b50e', __exports__)
  }
  
  module.hot.accept("./SidebarMenuItem.vue?vue&type=template&id=0751b50e&scoped=true", () => {
    api.rerender('0751b50e', render)
  })

}


export default __exports__